module.exports = __webpack_public_path__ + "img/5-0-0.d6e324a6.png";